//5,4,3 china
//2美国
// const data = JSON.parse(JSON.stringify(data2))
// const res = data.routes.filter(it => it[0] == 9)
// data.routes = res
export default {
  methods: {
    async baseEarthPlugin(opt, echarts, url) {
      let hubeiChartOpt = opt.chartOption
      const flightsJSON = this.instance.get("sv2/assets/flights.json")
      Promise.all([flightsJSON]).then(values => {
        let data = values[0].data
        data.routes = data.routes.filter(it => it[0] == 9)
        //处理飞线
        var airports = data.airports.map(function (item) {
          return {
            coord: [item[3], item[4]]
          }
        })
        function getAirportCoord(idx) {
          return [data.airports[idx][3], data.airports[idx][4]]
        }
        // Route: [airlineIndex, sourceAirportIndex, destinationAirportIndex]
        var routesGroupByAirline = {}
        data.routes.forEach(function (route) {
          var airline = data.airlines[route[0]]
          var airlineName = airline[0]
          if (!routesGroupByAirline[airlineName]) {
            routesGroupByAirline[airlineName] = []
          }
          routesGroupByAirline[airlineName].push(route)
        })
        var pointsData = []
        data.routes.forEach(function (airline) {
          pointsData.push(getAirportCoord(airline[1]))
          pointsData.push(getAirportCoord(airline[2]))
        })
        var series = data.airlines
          .map(function (airline) {
            var airlineName = airline[0]
            var routes = routesGroupByAirline[airlineName]
            if (!routes) {
              return null
            }
            return {
              type: "lines3D",
              name: airlineName,
              effect: {
                show: true,
                trailWidth: 2,
                trailLength: 0.15,
                trailOpacity: 1,
                trailColor: "rgba(0, 71, 255, 1)"
              },
              lineStyle: {
                width: 1,
                color: "rgba(0, 71, 255, 1)",
                // color: 'rgb(118, 233, 241)',
                opacity: 0.1
              },
              blendMode: "source-over",
              data: routes.map(function (item) {
                return [airports[item[1]].coord, airports[item[2]].coord]
              })
            }
          })
          .filter(function (series) {
            return !!series
          })
        series.push({
          type: "scatter3D",
          coordinateSystem: "globe",
          blendMode: "lighter",
          symbolSize: 2,
          itemStyle: {
            color: "transparent",
            opacity: 0.2
          },
          data: pointsData
        })
        //处理飞线结束
        const globalOpt = {
          backgroundColor: "transparent",
          globe: {
            globeRadius: 70,
            // baseTexture: earth,
            baseTexture:`${process.env.VUE_APP_STATIC_URL}/sv2/assets/image/earth3.png`,
            // displacementScale: 0.1,
            shading: "lambert",
            light: {
              ambient: {
                intensity: 0.6
              }
            },

            atmosphere: {
              show: true,
              color: "rgb(27,66,144)"
            }
          },
          series: series
        }
        Object.assign(hubeiChartOpt, globalOpt)
        this.reloadChart()
      })
      console.log(this.$refs.map)
    },
    beforeUpdate() {
      if (!this.options.chartOption.pluginName.find(it => it === "baseEarthPlugin")) {
        this.showChart = true
      }
    }
  }
}
